import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SavedSearchList from 'components/saved_search/list';

import { loadSearchQuery, startDeleteSearch } from '../store/actions/saved_searches';
import { getSearches } from '../store/selectors/saved_searches';
import { listFilters } from 'helpers/requirements/filters_helpers';

export class RequirementsSavedSearchList extends React.Component {
  static propTypes = {
    searches: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      query: PropTypes.object.isRequired
    })).isRequired,
    onDelete: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired
  };

  closeOuterPopover() {
    // TODO: Remove dependency on popover in this component
    document.body.click();
  }

  handleCancel = (search) => {
    this.closeOuterPopover();
    this.props.onDelete(search);
  }

  handleSelect = (search) => {
    this.closeOuterPopover();
    this.props.onSelect(search);
  }

  render() {
    return (
      <SavedSearchList
        {...this.props}
        listFilters={listFilters}
        onDelete={this.handleCancel}
        onSelect={this.handleSelect}
      />
    );
  }
}

const mapStateToProps = state => ({
  searches: getSearches(state)
});

const mapDispatchToProps = {
  onDelete: startDeleteSearch,
  onSelect: loadSearchQuery
};

export default connect(mapStateToProps, mapDispatchToProps)(RequirementsSavedSearchList);
